import { type ReactElement, type ReactNode, useEffect, useState } from "react"
import { EndUserInstanceLocationType } from "../../types/EndUserInstanceLocationType"
import { AppDispatch } from "src/app/store";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "src/app/store";
import Modal from "src/components/Modal";
import { useForm, SubmitHandler, Controller } from "react-hook-form";
import Button from "src/components/Button";
import { getUpdateList, updateAdapter } from "../../hooks/adapterUpdate";
import Root from "postcss/lib/root";
import Spinner from "src/components/Spinner";
import { AdapterUpdateType } from "../../types/AdapterUpdateType";

export interface AdapterUpdateModalProps {
        title: string,
        isOpen: boolean,
        // adapterUpdate: AdapterUpdateType | undefined,
        onClose: () => void,
        selectedEndUserInstanceLocation: EndUserInstanceLocationType | undefined,
        // onSubmit: (value: AdapterUpdateType) => void,
        children?: ReactNode,
}

const initialAdapterUpdate = {
        Version: "",
        EndUserInstanceLocationID: 0
}

export default function AdapterUpdateModal(props: AdapterUpdateModalProps): ReactElement {
        const dispatch = useDispatch<AppDispatch>();
        const { control, register, handleSubmit, reset, clearErrors, setError, formState: { errors, isSubmitting } } = useForm<AdapterUpdateType>(
                {
                        defaultValues: {
                                Version: "update_" + props.selectedEndUserInstanceLocation?.Version
                        }
                }
        );
        const { authUser } = useSelector((state: RootState) => state.auth);
        const { updateList, updateListLoading, updateListError } = useSelector((state: RootState) => state.adapterUpdate);
        const [selectedUpdate, setSelectedUpdate] = useState<string>("");

        const onSubmit: SubmitHandler<AdapterUpdateType> = (data) => {
                const current_version = Number(props.selectedEndUserInstanceLocation?.Version.replace(".", ""));
                const lat_ver: string[] = data.Version.split("_");
                const latestVersion = Number(lat_ver[1].replace(".", ""));
                data.EndUserInstanceLocationID = props.selectedEndUserInstanceLocation?.Id;
                if (latestVersion > current_version) {
                        // console.log("Please Update");
                        dispatch(updateAdapter(data));
                }
                else {
                        console.log("Do not Update");
                }
        }

        const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
                setSelectedUpdate(event.target.value);
        };

        useEffect(() => {
                let error = "";
                dispatch(getUpdateList(""));
                setError("root", {
                        type: "manual",
                        message: error,
                });
        }, [])

        const authorized = authUser?.UserType === "admin" ? false : true;

        return <>
                <Modal isOpen={props.isOpen} modalSize="lg" onClose={props.onClose}>
                        <h2 className="text-lg font-bold text-center">
                                {props.title}
                        </h2>
                        {
                                updateListLoading ? <Spinner title="loading" /> :
                                        <form className="flex flex-col gap-5" onSubmit={handleSubmit(onSubmit)}>
                                                <div className="mb-4 flex flex-col items-center">
                                                        <label className="block text-sm">There is a new Update for your DSX-Cloud Adapter!</label>
                                                        {
                                                                updateList.map((option) => (
                                                                        <label key={option}>
                                                                                <input type="radio" id={option} value={option} {...register('Version')} checked={selectedUpdate == option} onChange={handleChange} />
                                                                                {option}
                                                                        </label>
                                                                ))
                                                        }

                                                </div>
                                                <div className="flex gap-16 justify-around">
                                                        <Button className="" size="lg" type="reset" buttonStyle="delete">Reset</Button>
                                                        <Button className="" size="lg" type="submit" buttonStyle="primary">Update</Button>
                                                </div>
                                        </form>
                        }
                        {errors.root && (
                                <div className="text-red-500 text-center">{errors.root.message}</div>
                        )}
                </Modal>
        </>
}
